module.exports = __webpack_public_path__ + "img/kl8lhc_bg.f503314c.png";